// Color Schemes
export const COLOR_SCHEMES = {
  slate: {
    name: 'Slate',
    primary: '#0f172a',
    accent: '#3b82f6',
    background: '#f8fafc',
    vibe: 'Professional, premium',
  },
  ocean: {
    name: 'Ocean',
    primary: '#1e3a5f',
    accent: '#0ea5e9',
    background: '#f0f9ff',
    vibe: 'Calm, corporate',
  },
  forest: {
    name: 'Forest',
    primary: '#14532d',
    accent: '#22c55e',
    background: '#f0fdf4',
    vibe: 'Growth, stability',
  },
  charcoal: {
    name: 'Charcoal',
    primary: '#18181b',
    accent: '#a1a1aa',
    background: '#fafafa',
    vibe: 'Minimal, modern',
  },
  clean: {
    name: 'Clean',
    primary: '#334155',
    accent: '#6366f1',
    background: '#ffffff',
    vibe: 'Light, airy',
  },
};

// Style Packs
export const STYLE_PACKS = {
  executive: {
    name: 'Executive',
    headlines: 'Playfair Display',
    headlineWeight: 700,
    subheads: 'Inter',
    subheadWeight: 600,
    body: 'Inter',
    bodyWeight: 400,
    vibe: 'Classic, boardroom',
  },
  modern: {
    name: 'Modern',
    headlines: 'Inter',
    headlineWeight: 700,
    subheads: 'Inter',
    subheadWeight: 600,
    body: 'Inter',
    bodyWeight: 400,
    vibe: 'Clean, tech',
  },
  bold: {
    name: 'Bold',
    headlines: 'Space Grotesk',
    headlineWeight: 700,
    subheads: 'Space Grotesk',
    subheadWeight: 600,
    body: 'Inter',
    bodyWeight: 400,
    vibe: 'Strong, confident',
  },
};

// Report Sections - EXACT ORDER per user specification (Jan 16, 2026)
export const REPORT_SECTIONS = [
  { id: 'header', name: 'Header', defaultOn: true, alwaysOn: true },
  { id: 'status', name: 'Status Indicator', defaultOn: true },
  { id: 'progress', name: 'Progress Bar', defaultOn: true },
  { id: 'timeline', name: 'Project Timeline', defaultOn: true },
  { id: 'metrics', name: 'Metrics Dashboard', defaultOn: true },
  { id: 'chart', name: 'Performance', defaultOn: true },
  { id: 'accomplishments', name: 'Accomplishments', defaultOn: true },
  { id: 'upcoming', name: 'Upcoming', defaultOn: true },
  { id: 'blockers', name: 'Blockers', defaultOn: true },
  { id: 'risks', name: 'Risks', defaultOn: true },
  { id: 'decisions', name: 'Decisions Needed', defaultOn: true },
  { id: 'budget', name: 'Budget Summary', defaultOn: true },
  { id: 'milestones', name: 'Milestone Tracker', defaultOn: true },
  { id: 'scope', name: 'Scope Summary', defaultOn: true },
  { id: 'notes', name: 'Notes', defaultOn: true },
  { id: 'attachments', name: 'Links', defaultOn: true },
  { id: 'kudos', name: 'Kudos', defaultOn: true },
];

// Pricing Tiers - Single tier at $29/month with all features
export const PRICING_TIERS = {
  trial: {
    name: 'Free Trial',
    price: 0,
    projectLimit: 999, // Full access during trial
    features: ['14 days', 'Unlimited projects', 'Full features', 'PDF export', 'Shareable URLs', 'Bulk PDF export'],
  },
  professional: {
    name: 'Professional',
    monthlyPrice: 29,
    annualPrice: 290,
    projectLimit: 999, // Unlimited projects
    features: ['Unlimited projects', 'PDF export (no watermark)', 'Report history', 'Shareable URLs', 'Bulk PDF export'],
  },
  // Legacy tier - maps to professional for existing users
  business: {
    name: 'Professional',
    monthlyPrice: 29,
    annualPrice: 290,
    projectLimit: 999,
    features: ['Unlimited projects', 'PDF export (no watermark)', 'Report history', 'Shareable URLs', 'Bulk PDF export'],
  },
};

// Status Colors
export const STATUS_COLORS = {
  on_track: { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-200', color: '#22c55e' },
  at_risk: { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-200', color: '#eab308' },
  off_track: { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-200', color: '#ef4444' },
};

// Milestone Statuses
export const MILESTONE_STATUSES = [
  { value: 'not_started', label: 'Not Started', color: 'bg-gray-100 text-gray-800' },
  { value: 'in_progress', label: 'In Progress', color: 'bg-blue-100 text-blue-800' },
  { value: 'complete', label: 'Complete', color: 'bg-green-100 text-green-800' },
  { value: 'at_risk', label: 'At Risk', color: 'bg-red-100 text-red-800' },
];

// Risk Levels
export const RISK_LEVELS = [
  { value: 'low', label: 'Low', color: 'bg-green-100 text-green-800' },
  { value: 'medium', label: 'Medium', color: 'bg-yellow-100 text-yellow-800' },
  { value: 'high', label: 'High', color: 'bg-red-100 text-red-800' },
];
